module.exports = __webpack_public_path__ + "08cd2cfcd1594814a5b723d991220570.svg";